import { combineReducers } from 'redux';
import TagFuncionalidadeReducer from 'app/ERP/TagFuncionalidade/Store/Reducers/TagFuncionalidadeReducer';
import CustomCrmFormReducer from './CustomCrmFormReducer';

const reducer = combineReducers({
    CustomCrmFormReducer,
    TagFuncionalidadeReducer
});

export default reducer;
